import React, { useState } from 'react';
import NavigationBar from './layout/NavigationBar';
import Sidebar from './layout/Sidebar';
import PageWrapper from './layout/PageWrapper';

interface LayoutProps {
  children: React.ReactNode;
  showSidebar?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, showSidebar = true }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen glass-page-bg transition-colors">
      {/* Top Navigation */}
      <NavigationBar />

      <div className="flex h-[calc(100vh-64px)]">
        {/* Sidebar */}
        {showSidebar && (
          <Sidebar
            isCollapsed={isSidebarCollapsed}
            onToggle={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
            className="flex-shrink-0 h-full overflow-y-auto"
          />
        )}

        {/* Main Content */}
        <div className="flex-1 h-full overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
